import { useCallback } from "react";

const { NODE_ENV } = process.env;

function useTriggerPostMessage(targetOrigin) {
  const triggerPostMessage = useCallback(
    function triggerPostMessage(sendAction, replyAction, payload) {
      return new Promise((resolve, reject) => {
        if (replyAction) {
          const postMessageEventListener = function postMessageEventListener(
            e
          ) {
            if (e.origin !== targetOrigin) {
              return;
            }

            const message = e.data;

            if (NODE_ENV === "development") {
              console.log(
                e.origin,
                message.action,
                message.payload,
                message.error
              );
            }

            if (message.action === replyAction) {
              window.removeEventListener("message", postMessageEventListener);
              if (message.error) {
                reject(new Error(message.error));
              } else {
                resolve(message.payload);
              }
            }
          };

          window.addEventListener("message", postMessageEventListener);

          window.top.postMessage(
            {
              action: sendAction,
              payload,
            },
            targetOrigin
          );
        } else {
          window.top.postMessage(
            {
              action: sendAction,
              payload,
            },
            targetOrigin
          );

          resolve();
        }
      });
    },
    [targetOrigin]
  );

  return triggerPostMessage;
}

export default useTriggerPostMessage;
